import './App.css';
import Home from './Pages/Home';
import Contact from './Components/Contact';
import AboutPage from './Pages/AboutPage';
import { BrowserRouter, Routes, Route  } from "react-router-dom";
import Services from './Components/Services';
import Partners from './Components/Partners';
import Sectors from './Components/Sectors';



function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<Services />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/sectors" element={<Sectors />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
